import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { DateTime } from "luxon";

import Localization from "../../../localization";
import Button from "../../../components/button";
import IconClose from "../../../components/icons/close";
import ModalCancel from "../../../components/modalCancel";
import IconSpinner from "../../../components/icons/spinner";
import { changeFaq, changeSpacesBooking } from "../../../redux/actions/options";
import {
    loadSpaceReservations,
    cancelReservation,
    cancelReservationBySlot,
} from "../../../redux/actions/spaceReservations";
import { getMe } from "../../../redux/selectors/me";
import { getSpaceReservations } from "../../../redux/selectors/spaceReservations";
import { loadPage } from "../../../redux/actions/pages";
import { getUrl, fixExternalLinks } from "../../../utils/helper";

class Spaces extends Component {
    constructor(props) {
        super(props);

        this._onBookingPress = this._onBookingPress.bind(this);
        this._cancelReservation = this._cancelReservation.bind(this);
        this._cancelReservationSlot = this._cancelReservationSlot.bind(this);

        this.state = {
            spaceReservationToCancel: null,
            spaceReservationSlotToCancel: null,
        };
    }

    componentDidMount() {
        this.props.loadPage("spaces");
        this.props.loadPage("spaces_booking");
        this.props.loadSpaceReservations();
    }

    _cancelReservation(spaceReservation) {
        if (this.props.isDeleting) return;

        this.setState({
            spaceReservationToCancel: spaceReservation.id,
        });
    }

    _cancelReservationSlot(id, date) {
        if (this.props.isDeleting) return;

        this.setState({
            spaceReservationSlotToCancel: {
                id,
                date: date[0] + "/" + date[1] + "/" + date[2],
            },
        });
    }

    _renderSpaceReservation(spaceReservation) {
        if (spaceReservation.dates.length === 0) return null;

        let finished = false;
        let lastFinished = false;
        const now = DateTime.local();
        let end = DateTime.fromISO(spaceReservation.dates[0][0]);
        end = end.set({ hour: spaceReservation.dates[0][1] });

        if (now.toMillis() >= end.toMillis()) finished = true;

        let last = DateTime.fromISO(
            spaceReservation.dates[spaceReservation.dates.length - 1][0]
        );
        last = last.set({
            hour: spaceReservation.dates[spaceReservation.dates.length - 1][1],
        });

        if (now.toMillis() >= last.toMillis()) lastFinished = true;

        return (
            <div
                key={spaceReservation.id}
                className={`flex items-start py-16 border-b border-blue ${
                    lastFinished ? "opacity-40" : ""
                }`}
            >
                <div className="flex-1">
                    <div className="flex flex-row">
                        <p className="text-17 xl:text-30 font-judge font-bold w-100 xl:w-200">
                            {DateTime.fromISO(
                                spaceReservation.created_at
                            ).toLocaleString(DateTime.DATE_SHORT)}
                        </p>
                        <p className="text-17 xl:text-30 font-judge font-bold flex-1">
                            {spaceReservation.space.name}
                        </p>
                        <p className="text-17 xl:text-30 font-judge font-bold xl:ml-40">
                            {spaceReservation.duration} horas
                        </p>
                    </div>
                    <div className="text-17 xl:text-23 font-bold mt-10 xl:mt-0 xl:pb-10 pl-100 xl:pl-200">
                        {spaceReservation.dates.map((date) => {
                            let dateFinished = false;
                            const now = DateTime.local();
                            let end = DateTime.fromISO(date[0]);
                            end = end.set({
                                hour: date[1],
                            });

                            if (now.toMillis() >= end.toMillis())
                                dateFinished = true;

                            return (
                                <div
                                    className={`flex mb-6 items-center ${
                                        dateFinished ? " opacity-40" : ""
                                    }`}
                                >
                                    <p
                                        key={
                                            date[0] +
                                            " — " +
                                            date[1] +
                                            ":00 às " +
                                            date[2] +
                                            ":00"
                                        }
                                    >
                                        {date[0] +
                                            " — " +
                                            date[1] +
                                            ":00 às " +
                                            date[2] +
                                            ":00"}
                                    </p>
                                    {!dateFinished &&
                                        spaceReservation.dates.length > 1 && (
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    this._cancelReservationSlot(
                                                        spaceReservation.id,
                                                        date
                                                    );
                                                }}
                                                className="ml-6 px-10"
                                            >
                                                <IconClose className="w-16 h-16 xl:w-20 xl:h-20" />
                                            </button>
                                        )}
                                </div>
                            );
                        })}
                    </div>
                </div>
                {!finished && (
                    <button
                        type="button"
                        onClick={() => {
                            this._cancelReservation(spaceReservation);
                        }}
                        className="py-4 pl-32 pr-16 -mr-16"
                    >
                        <IconClose className="w-20 xl:w-26 h-20 xl:h-26" />
                    </button>
                )}
            </div>
        );
    }

    _renderHistory() {
        const { spaceReservations, isDeleting, locale } = this.props;

        if (isDeleting)
            return (
                <div className="mt-30 xl:mt-60">
                    <IconSpinner className="animate-spin w-25 xl:w-32 h-25 xl:h-32 text-blue" />
                </div>
            );

        if (spaceReservations && spaceReservations.length === 0) return null;

        return (
            <div className="mt-30 xl:mt-60">
                <p className="text-30 font-judge font-bold">
                    {Localization[locale].account.history}
                </p>
                <div className="border-t border-blue mt-30 xl:mt-40">
                    {spaceReservations.map((spaceReservation) =>
                        this._renderSpaceReservation(spaceReservation)
                    )}
                </div>
            </div>
        );
    }

    _onBookingPress() {
        this.props.changeSpacesBooking(true);
    }

    _renderQuota(isQuotaEmpty) {
        const { locale, user } = this.props;

        if (!isQuotaEmpty) return null;

        const now = DateTime.local();
        const end = DateTime.fromISO(user.reset_quota_date);
        const diff = end.diff(now, ["days"]);

        if (diff.toObject().days)
            return (
                <p className="text-17 xl:text-23 text-orange leading-tight font-bold mb-12">
                    {Localization[locale].account.quota_empty(
                        diff.toObject().days.toFixed(0)
                    )}
                </p>
            );
    }

    render() {
        const { user, spacesData, spacesBookingData, locale } = this.props;
        const { spaceReservationToCancel, spaceReservationSlotToCancel } =
            this.state;

        if (!user || !spacesData)
            return (
                <div className="flex h-screen xl:h-auto items-center justify-center">
                    <IconSpinner className="animate-spin w-25 xl:w-32 h-25 xl:h-32 text-blue" />
                </div>
            );

        if (!user.is_local) return null;

        const isQuotaEmpty = user.available_quota <= 0 || user.blocked;

        let bookingButtonTextStyle =
            "font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue";

        if (isQuotaEmpty)
            bookingButtonTextStyle =
                "font-bold text-20 xl:text-23 z-10 text-center text-blue";

        return (
            <div>
                <div className="xl:flex">
                    <div className="relative">
                        <p className="text-30 font-judge font-bold mr-100 mb-20 xl:mb-30">
                            {Localization[locale].account.space_type}
                        </p>
                        {this._renderQuota(isQuotaEmpty)}
                        <div className="xl:hidden absolute right-0 top-0">
                            <Button
                                icon={
                                    <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-white text-blue" />
                                }
                                to={getUrl("account")}
                                style={"w-50 xl:w-70"}
                            />
                        </div>
                        <p className="xl:hidden text-20 mt-40 font-judge font-bold text-orange">
                            {user.available_quota +
                                " " +
                                Localization[locale].account.available_quota}
                        </p>
                        {spacesBookingData &&
                            spacesBookingData.content.map((section) => (
                                <div
                                    className="article-body text-17 xl:text-23 leading-tight font-bold whitespace-pre-wrap"
                                    dangerouslySetInnerHTML={{
                                        __html: fixExternalLinks(
                                            section.attributes.body
                                        ),
                                    }}
                                />
                            ))}
                    </div>
                    <p className="hidden xl:block shrink-0 text-30 text-right font-judge font-bold text-orange w-200">
                        {user.available_quota +
                            " " +
                            Localization[locale].account.available_quota}
                    </p>
                </div>
                <div className="flex flex-col xl:flex-row flex-wrap mt-20 xl:mt-30 xl:-mx-8">
                    <Button
                        text={Localization[locale].account.button_booking}
                        textStyle={bookingButtonTextStyle}
                        disable={isQuotaEmpty}
                        style={"mb-8 xl:m-8"}
                        wrapperStyle="px-20"
                        backgroundColor={"bg-grey"}
                        onClick={this._onBookingPress}
                    />
                    <Button
                        text={Localization[locale].account.button_terms}
                        textStyle={
                            "font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                        }
                        style={"mb-8 xl:m-8"}
                        wrapperStyle="px-20"
                        backgroundColor={"bg-grey"}
                        url={spacesData.pdf}
                    />
                    <Button
                        text={Localization[locale].account.button_faqs}
                        textStyle={
                            "font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                        }
                        style={"mb-8 xl:m-8"}
                        wrapperStyle="px-20"
                        backgroundColor={"bg-grey"}
                        toTarget="_blank"
                        onClick={() => {
                            this.props.changeFaq(true, 2);
                        }}
                    />
                </div>
                {user.blocked && (
                    <p className="text-red text-12 mt-4">
                        {Localization[locale].account.blocked}
                        <a
                            className="underline"
                            href="mailto:campuspcs@agoraporto.pt"
                        >
                            campuspcs@agoraporto.pt
                        </a>
                        .
                    </p>
                )}
                {this._renderHistory()}
                <ModalCancel
                    visible={!!spaceReservationToCancel}
                    data={spaceReservationToCancel}
                    title={Localization[locale].spaces_booking.cancel_title}
                    text={Localization[locale].spaces_booking.cancel_text}
                    onClose={(cancelId) => {
                        if (cancelId) {
                            this.props.cancelReservation(cancelId);
                        }
                        this.setState({
                            spaceReservationToCancel: null,
                        });
                    }}
                />
                <ModalCancel
                    visible={!!spaceReservationSlotToCancel}
                    data={spaceReservationSlotToCancel}
                    title={Localization[locale].spaces_booking.cancel_title}
                    text={Localization[locale].spaces_booking.cancel_text}
                    onClose={(cancel) => {
                        if (cancel) {
                            this.props.cancelReservationBySlot(
                                cancel.id,
                                cancel.date
                            );
                        }
                        this.setState({
                            spaceReservationSlotToCancel: null,
                        });
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    user: getMe(state),
    spaceReservations: getSpaceReservations(state),
    spacesData: state.pages.spaces,
    spacesBookingData: state.pages.spaces_booking,
    isDeleting: state.spaceReservations.isDeleting,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            loadPage,
            changeSpacesBooking,
            loadSpaceReservations,
            cancelReservation,
            cancelReservationBySlot,
            changeFaq,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Spaces);
